import React from "react";
import "./wrapper.scss";

const Wrapper = ({ children }) => {
  return (
    <section className="wrapper">
      <div className="wrapper__child">{children}</div>
    </section>
  );
};

export default Wrapper;
